module.exports = __webpack_public_path__ + "media/customizations/mylwr/logo-new-8d2bec3a58c1f53e1c46f4d0cc0270db.png";